var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isLogin)?_c('router-view'):_vm._e(),(!_vm.isLogin)?_c('Layout',{class:'bg-danger w-100 h-100 position-fixed'},[_c('Login')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }